// export const API_URL = process.env.API_URL;
export const API_URL=process.env.REACT_APP_API_URL;
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export const MAPBOX_STYLE = process.env.REACT_APP_MAPBOX_STYLE;
